import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpService } from 'src/app/http.service';

// Drill-down page for the Company Agent Report: lists every player who bet on ONE
// game (game_id + platform/platform_type cell) over the SAME filtered date range,
// with that player's winloss for that date. Reached by clicking a game row in
// IntegrationReportComponent. Identity + dates ride in the query string so the page
// is refresh-safe; game_title rides in navigation state for a nicer header.
@Component({
  selector: 'app-agent-report-player-detail',
  templateUrl: './agent-report-player-detail.component.html',
  styleUrls: ['./agent-report-player-detail.component.scss'],
})
export class AgentReportPlayerDetailComponent implements OnInit {

  public company_uuid = '';
  public is_loading = false;

  public game_id: any = null;
  public platform = '';
  public platform_type = '';
  public from = '';
  public to = '';
  public game_title = '';

  public players: any[] = [];

  constructor(
    private http: HttpService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    const nav = this.router.getCurrentNavigation();
    const st = nav?.extras?.state as any;
    if (st && st.game_title) this.game_title = st.game_title;
    if (st && (st.platform || st.platform === '')) this.platform = st.platform || '';
    if (st && (st.platform_type || st.platform_type === '')) this.platform_type = st.platform_type || '';
  }

  ngOnInit() {
    this.company_uuid = this.http.getStaticSelectedCompany();
    this.route.queryParams.subscribe((q) => {
      this.game_id = q['game_id'] || null;
      // Query params win over state (they survive a refresh).
      if (q['platform'] !== undefined) this.platform = q['platform'] || '';
      if (q['platform_type'] !== undefined) this.platform_type = q['platform_type'] || '';
      this.from = q['from'] || '';
      this.to = q['to'] || '';
      this.load();
    });
  }

  async load() {
    if (!this.game_id) {
      this.players = [];
      return;
    }
    this.is_loading = true;
    try {
      const body: any = {
        game_id: this.game_id,
        platform: this.platform,
        platform_type: this.platform_type,
        from: this.from,
        to: this.to,
      };
      const rtn: any = await this.http.post('/admin/seemless-game/agent-log/player-detail', body);
      this.players = rtn && rtn.status ? (rtn.players || []) : [];
    } finally {
      this.is_loading = false;
    }
  }

  gameLabel(): string {
    let label = this.game_title || ('Game #' + this.game_id);
    if (this.platform) {
      label += ' (' + this.platform + (this.platform_type ? ' - ' + this.platform_type : '') + ')';
    }
    return label;
  }

  back() {
    this.router.navigate(['/lo', this.company_uuid, 'agent-report']);
  }

  sum(key: string): number {
    return this.players.reduce((acc: number, p: any) => acc + parseFloat(p[key] ?? 0), 0);
  }
}
